import { render } from "./TheCart.vue?vue&type=template&id=16f5975a"
import script from "./TheCart.vue?vue&type=script&lang=js"
export * from "./TheCart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/petertoh/Sites/martin-keehn/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__